import { render } from "./Product.vue?vue&type=template&id=f837d92e&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=f837d92e&lang=scss&scoped=true"

import exportComponent from "D:\\POS 22\\pawhouse\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f837d92e"]])

export default __exports__